/**
 * Hierarchical Category Navigation JavaScript - Simplified
 */

// Simple, reliable implementation
function initHierarchicalNav() {
  const containers = document.querySelectorAll('[data-nav-container]');
  
  // If no hierarchical nav containers found, exit early
  if (containers.length === 0) {
    return;
  }
  
  // Initialize the correct view based on current state
  containers.forEach(container => {
    initializeCorrectView(container);
  });
  
  containers.forEach(container => {
    const menuId = container.getAttribute('data-nav-container');
    
    // Category buttons (main level)
    const categoryButtons = container.querySelectorAll('[data-category-btn]');
    
    categoryButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const categoryHandle = button.getAttribute('data-category-btn');
        const buttonMenuId = button.getAttribute('data-menu-id');
        
        // Only handle clicks for this menu instance
        if (buttonMenuId !== menuId) return;
        
        // Check if this category has sub-categories by looking for arrow icon
        const hasSubCategories = button.querySelector('.hierarchical-nav-arrow');
        
        // Always prevent default navigation from the button
        e.preventDefault();
        
        if (hasSubCategories) {
          // Has sub-categories: just show focused view
          showCategoryLevel(container, categoryHandle);
        } else {
          // No sub-categories: show focused view and navigate immediately
          showCategoryLevel(container, categoryHandle);
          
          // Check if we're in mobile drawer - if so, navigate immediately
          const isMobileDrawer = container.closest('.unified-mobile-nav-drawer') || 
                                container.closest('.hierarchical-nav-mobile-drawer');
          
          if (isMobileDrawer) {
            // Mobile: Navigate immediately and close drawer
            const categoryLevel = container.querySelector(`[data-nav-level="${categoryHandle}"]`);
            if (categoryLevel) {
              const categoryLink = categoryLevel.querySelector('.hierarchical-nav-parent-focus a[href]');
              if (categoryLink) {
                // Close the mobile drawer first
                const drawer = container.closest('.unified-mobile-nav-drawer');
                const overlay = document.querySelector('.unified-mobile-nav-overlay');
                if (drawer) {
                  drawer.classList.remove('open');
                  overlay?.classList.remove('active');
                  document.body.style.overflow = '';
                }
                
                // Small delay then navigate
                setTimeout(() => {
                  window.location.href = categoryLink.href;
                }, 150);
              }
            }
          } else {
            // Desktop: Navigate immediately while showing focused view
            const categoryLevel = container.querySelector(`[data-nav-level="${categoryHandle}"]`);
            if (categoryLevel) {
              const categoryLink = categoryLevel.querySelector('.hierarchical-nav-parent-focus a[href]');
              if (categoryLink) {
                // Small delay to allow focused view to show, then navigate
                setTimeout(() => {
                  window.location.href = categoryLink.href;
                }, 200);
              }
            }
          }
        }
      });
    });

    // Back to main buttons
    const backButtons = container.querySelectorAll(`[data-back-to-main="${menuId}"]`);
    
    backButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        showMainLevel(container);
      });
    });
  });
  
  // Mobile functionality
  setupMobileNav();
  setupUnifiedMobileNav();
}

function showMainLevel(container) {
  // Hide all category levels
  const categoryLevels = container.querySelectorAll('[data-nav-level]:not([data-nav-level="main"])');
  categoryLevels.forEach(level => {
    level.setAttribute('data-active', 'false');
    level.style.display = 'none';
  });
  
  // Show main level
  const mainLevel = container.querySelector('[data-nav-level="main"]');
  if (mainLevel) {
    mainLevel.setAttribute('data-active', 'true');
    mainLevel.style.display = 'block';
  }
}

function showCategoryLevel(container, categoryHandle) {
  // Hide main level
  const mainLevel = container.querySelector('[data-nav-level="main"]');
  if (mainLevel) {
    mainLevel.setAttribute('data-active', 'false');
    mainLevel.style.display = 'none';
  }
  
  // Hide all other category levels
  const allCategoryLevels = container.querySelectorAll('[data-nav-level]:not([data-nav-level="main"])');
  allCategoryLevels.forEach(level => {
    level.setAttribute('data-active', 'false');
    level.style.display = 'none';
  });
  
  // Show target category level
  const targetLevel = container.querySelector(`[data-nav-level="${categoryHandle}"]`);
  if (targetLevel) {
    targetLevel.setAttribute('data-active', 'true');
    targetLevel.style.display = 'block';
  }
}

function initializeCorrectView(container) {
  // Find which level should be active (has data-active="true")
  const activeLevel = container.querySelector('[data-nav-level][data-active="true"]');
  
  if (activeLevel) {
    // Hide all other levels
    const allLevels = container.querySelectorAll('[data-nav-level]');
    allLevels.forEach(level => {
      if (level !== activeLevel) {
        level.setAttribute('data-active', 'false');
        level.style.display = 'none';
      } else {
        level.style.display = 'block';
      }
    });
  } else {
    // If no data-nav-level elements found, ensure main level is shown for all containers
    const mainLevel = container.querySelector('[data-nav-level="main"]');
    if (mainLevel) {
      mainLevel.setAttribute('data-active', 'true');
      mainLevel.style.display = 'block';
      
      // Hide all other levels
      const allOtherLevels = container.querySelectorAll('[data-nav-level]:not([data-nav-level="main"])');
      allOtherLevels.forEach(level => {
        level.setAttribute('data-active', 'false');
        level.style.display = 'none';
      });
    }
  }
}


function setupMobileNav() {
  // Handle multiple mobile navigation instances
  const mobileToggles = document.querySelectorAll('[data-hierarchical-toggle]');
  
  mobileToggles.forEach(toggle => {
    const menuId = toggle.getAttribute('data-hierarchical-toggle');
    const mobileDrawer = document.querySelector(`[data-hierarchical-drawer="${menuId}"]`);
    const mobileOverlay = document.querySelector(`[data-hierarchical-overlay="${menuId}"]`);
    const mobileClose = document.querySelector(`[data-hierarchical-close="${menuId}"]`);
    
    if (toggle && mobileDrawer) {
      toggle.addEventListener('click', () => {
        // Close other drawers first
        const allDrawers = document.querySelectorAll('[data-hierarchical-drawer]');
        const allOverlays = document.querySelectorAll('[data-hierarchical-overlay]');
        allDrawers.forEach(drawer => drawer.classList.remove('open'));
        allOverlays.forEach(overlay => overlay.classList.remove('active'));
        
        // Open this drawer
        mobileDrawer.classList.toggle('open');
        mobileOverlay?.classList.toggle('active');
        document.body.style.overflow = mobileDrawer.classList.contains('open') ? 'hidden' : '';
      });
      
      mobileClose?.addEventListener('click', () => {
        mobileDrawer.classList.remove('open');
        mobileOverlay?.classList.remove('active');
        document.body.style.overflow = '';
      });
      
      mobileOverlay?.addEventListener('click', () => {
        mobileDrawer.classList.remove('open');
        mobileOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
  });
}

function setupUnifiedMobileNav() {
  // Use a more aggressive approach - try multiple selectors and methods
  setTimeout(() => {
    // Method 1: Data attribute
    let toggle = document.querySelector('[data-unified-nav-toggle]');
    
    // Method 2: Class name if data attribute fails
    if (!toggle) {
      toggle = document.querySelector('.unified-mobile-nav-toggle');
    }
    
    // Method 3: Button with specific text
    if (!toggle) {
      const buttons = document.querySelectorAll('button');
      for (let btn of buttons) {
        if (btn.textContent.includes('VIEW FILTERS')) {
          toggle = btn;
          break;
        }
      }
    }
    
    if (toggle) {
      // Remove any existing listeners
      toggle.replaceWith(toggle.cloneNode(true));
      toggle = document.querySelector('.unified-mobile-nav-toggle') || 
               document.querySelector('[data-unified-nav-toggle]');
      
      if (toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Find drawer elements
          let drawer = document.querySelector('[data-unified-nav-drawer]') || 
                      document.querySelector('.unified-mobile-nav-drawer');
          let overlay = document.querySelector('[data-unified-nav-overlay]') || 
                       document.querySelector('.unified-mobile-nav-overlay');
          
          if (drawer) {
            // Close any other drawers
            document.querySelectorAll('[data-hierarchical-drawer]').forEach(d => d.classList.remove('open'));
            document.querySelectorAll('[data-hierarchical-overlay]').forEach(o => o.classList.remove('active'));
            
            // Toggle this drawer
            const isOpen = drawer.classList.contains('open');
            if (isOpen) {
              drawer.classList.remove('open');
              overlay?.classList.remove('active');
              document.body.style.overflow = '';
            } else {
              drawer.classList.add('open');
              overlay?.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          }
        });
        
        // Also add touch event for mobile
        toggle.addEventListener('touchstart', function(e) {
          e.preventDefault();
          toggle.click();
        });
      }
    }
    
    // Setup close button
    const closeBtn = document.querySelector('[data-unified-nav-close]') || 
                    document.querySelector('.unified-mobile-nav-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        const drawer = document.querySelector('.unified-mobile-nav-drawer');
        const overlay = document.querySelector('.unified-mobile-nav-overlay');
        if (drawer) {
          drawer.classList.remove('open');
          overlay?.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
    
    // Setup overlay close
    const overlay = document.querySelector('.unified-mobile-nav-overlay');
    if (overlay) {
      overlay.addEventListener('click', function() {
        const drawer = document.querySelector('.unified-mobile-nav-drawer');
        if (drawer) {
          drawer.classList.remove('open');
          overlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
  }, 100); // Small delay to ensure DOM is ready
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initHierarchicalNav();
});

// Also try immediate initialization in case DOM is already loaded
if (document.readyState !== 'loading') {
  initHierarchicalNav();
}

// Additional initialization attempts for mobile nav
setTimeout(() => {
  setupUnifiedMobileNav();
}, 500);

setTimeout(() => {
  setupUnifiedMobileNav();
}, 1000);

// Try again when window loads
window.addEventListener('load', () => {
  setTimeout(setupUnifiedMobileNav, 200);
});

// Hide filter button when Shopify overlays are open
function setupOverlayDetection() {
  const filterButton = document.querySelector('.unified-mobile-nav-toggle');
  if (!filterButton) return;
  
  // Watch for menu drawer changes
  const menuDrawer = document.querySelector('menu-drawer');
  if (menuDrawer) {
    const observer = new MutationObserver(() => {
      if (menuDrawer.hasAttribute('open')) {
        filterButton.style.display = 'none';
      } else {
        filterButton.style.display = '';
      }
    });
    observer.observe(menuDrawer, { attributes: true });
  }
  
  // Watch for search modal changes
  const searchModal = document.querySelector('details-modal.header__search, .predictive-search');
  if (searchModal) {
    const observer = new MutationObserver(() => {
      if (searchModal.hasAttribute('open') || searchModal.classList.contains('predictive-search--search-focused')) {
        filterButton.style.display = 'none';
      } else {
        filterButton.style.display = '';
      }
    });
    observer.observe(searchModal, { attributes: true, attributeFilter: ['open', 'class'] });
  }
  
  // Watch for any details elements opening
  document.addEventListener('toggle', (e) => {
    if (e.target.tagName === 'DETAILS' && e.target.open) {
      filterButton.style.display = 'none';
    } else if (e.target.tagName === 'DETAILS' && !e.target.open) {
      // Check if any other details are still open
      const openDetails = document.querySelector('details[open]');
      if (!openDetails) {
        filterButton.style.display = '';
      }
    }
  });
  
  // Watch for aria-expanded changes (common in Shopify components)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
        const target = mutation.target;
        if (target.getAttribute('aria-expanded') === 'true') {
          filterButton.style.display = 'none';
        } else {
          // Check if any other expanded elements exist
          const expanded = document.querySelector('[aria-expanded="true"]');
          if (!expanded) {
            filterButton.style.display = '';
          }
        }
      }
    });
  });
  
  // Observe the entire document for aria-expanded changes
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-expanded']
  });
}


// Initialize overlay detection
setTimeout(setupOverlayDetection, 1000);
